import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import HelpIcon from '@mui/icons-material/Help';
import Paper, { PaperProps } from '../../library/Paper';
import { MuiGrid } from '../../../../../modules/material';
import Typography from '../../library/Typography';
import { StyledButton, StyledButtonWrapper, StyledCircledIcon } from './styles';
import { useTheme } from '@mui/material/styles';

interface ContactUsWidgetProps extends PaperProps {
  title?: string;
  subTitle?: string;
  email?: string;
}

export default function ContactUsWidget(props: ContactUsWidgetProps) {
  const { title, subTitle, email, ...paperProps } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Paper
      neutralBackgroundColor={200}
      {...paperProps}
      className={cn(paperProps.className, 'informa-payment-contact-us-widget')}
    >
      <MuiGrid container spacing={2}>
        <MuiGrid
          item
          xs={12}
          sm={8}
          sx={{ display: 'flex', alignItems: 'flex-start' }}
        >
          <StyledCircledIcon backgroundRGBColor={theme.palette.neutral.RGB0}>
            <HelpIcon
              sx={{
                color: 'var(--payment-palette-primary)',
              }}
            />
          </StyledCircledIcon>
          <div>
            {title && (
              <Typography
                variant="h5"
                paletteColorName="brandSecondary"
                className="informa-payment-contact-us-widget__title"
              >
                {title}
              </Typography>
            )}
            {subTitle && (
              <Typography
                variant="body1"
                neutralColorIndex={600}
                className="informa-payment-contact-us-widget__sub-title"
              >
                {subTitle}
              </Typography>
            )}
          </div>
        </MuiGrid>
        <StyledButtonWrapper item xs={12} sm={4}>
          {email && (
            <StyledButton
              href={`mailto:${email}`}
              variant="outlined"
              size="small"
            >
              {t('site.pricing.contact-us-widget.button.label')}
            </StyledButton>
          )}
        </StyledButtonWrapper>
      </MuiGrid>
    </Paper>
  );
}
